module.exports = __webpack_public_path__ + "static/scoring-2-cd9cf10d17eb2ff972c60ff19a25fbe6.png";